<!-- 问题反馈 -->
<template>
    <div>
        <Panel title="组件实现管理">
            <template slot="buttons">
                <el-button title="查询" class="blue" @click="pageTable.handleLoad()" icon="el-icon-fa-search">查询</el-button>
                <el-button title="重置" class="yellow" @click="pageTable.handleReset()" icon="el-icon-fa-refresh">重置</el-button>
            </template>

            <el-form ref="queryForm">
                <el-row>
                    <el-col :lg='4' :sm='12'>
                        <el-form-item prop="impl_defn" label="组件标识">
                            <el-input v-model="pageTable.param.impl_defn"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg='4' :sm='12'>
                        <el-form-item prop="impl_name" label="组件名称">
                            <el-input v-model="pageTable.param.impl_name"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg='4' :sm='12'>
                        <el-form-item prop="impl_class" label="实现类">
                            <el-input v-model="pageTable.param.impl_class"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </Panel>
        <Panel title="组件列表">
            <template slot="buttons">
                <el-button title="新增" class="green" icon="el-icon-fa-plus" @click="doAdd">新增</el-button>
                <el-button title="删除" class="red" icon="el-icon-fa-trash" @click="doSeleDel">删除</el-button>
            </template>
            <el-table highlight-current-row stripe border :data="pageTable.data" v-loading="pageTable.isLoading"
                      ref="table" @selection-change="handleSelectionChange" element-loading-spinner="el-icon-loading"
                      element-loading-text="数据加载中" height="calc(100vh - 280px)">
                <el-table-column prop="$rownum" label="NO." width="50" align="center"/>
                <el-table-column type="selection" align='center' width="50"></el-table-column>
                <el-table-column prop="impltype" label="组件类型" show-overflow-tooltip width="100" :formatter="formatter"></el-table-column>
                <el-table-column prop="impldefn" label="组件标识" show-overflow-tooltip></el-table-column>
                <el-table-column prop="implname" label="组件名称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="implclass" label="实现类" show-overflow-tooltip></el-table-column>
                <el-table-column prop="opcomment" label="备注" show-overflow-tooltip></el-table-column>
                <el-table-column label="操作" width="150" align="center">
                    <template slot-scope="scope">
                        <el-button title="编辑" class="blue" @click="doEdit(scope.$index, scope.row)" icon="el-icon-fa-edit">编辑</el-button>
                        <el-button title="删除" class="red" @click="doDelete( scope.$index, scope.row)" icon="el-icon-fa-trash">删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <export-ctrl class="pull-left" @export="pageTable.handleExport($event, $refs.table)"/>
            <el-pagination background :page-size.sync="pageTable.size" :current-page.sync="pageTable.curr" :total="pageTable.total"/>
        </Panel>


        <el-dialog close-on-press-escape append-to-body v-draggable :visible.sync="editor.show" title="组件实现编辑" width="40%">
            <div class="dialog-button">
                <el-button title="保存" class="blue" @click="refsaveImplClass" icon="el-icon-fa-save">保存</el-button>
            </div>
            <div v-if="editor.show">
                <ImplClassEdit v-if="editor.show" ref="edit" :dat='postdat'
                               @upd='() => {editor.show = false; pageTable.handleLoad()}'></ImplClassEdit>
            </div>
        </el-dialog>

    </div>
</template>

<script>
    import ImplClassEdit from "./ImplClassEdit";
    import ImplClassApi from "./ImplClass";
    import {PageTable} from 'cnetong-core-frontend';

    export default {
        components: {ImplClassEdit},
        data() {
            return {
                pageTable: new PageTable({
                    autoLoad: true,
                    doLoad: ImplClassApi.queryImplClassList
                }),
                postdat: {},
                editor: {
                    show: false,
                    loading: false
                },
                multipleSelection: []
            };
        },
        methods: {
            // 打开编辑页面
            async refsaveImplClass() {
                await this.confirm();
                this.$refs.edit.saveImplClass();
            },
            doEdit(index, rowData) {
                this.loading = true;
                this.postdat = rowData;
                this.postdat.typeedit = true;
                this.editor.show = true;
                this.loading = false;
            },
            doAdd() {
                this.loading = true;
                this.postdat = {};
                this.editor.show = true;
                this.loading = false;
            },
            async doDelete(index, rowData) {
                try {
                    await this.confirm();
                    this.pageTable.isLoading = true;
                    await ImplClassApi.delImplClass([rowData.uuid]);
                    this.pageTable.handleLoad();
                } finally {
                    this.pageTable.isLoading = false;
                }
            },
            formatter(row, column, value) {
                if (value === 1) {
                    return "系统组件";
                } else if (value === 2) {
                    return "路由组件";
                } else if (value === 3) {
                    return "对接协议";
                } else {
                    return "error";
                }
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            async doSeleDel() {
                if (this.multipleSelection.length === 0) {
                    this.$message.warning("请选择数据！");
                    return;
                }
                try {
                    await this.confirm();
                    this.pageTable.isLoading = true;
                    let array = this.multipleSelection.map(v => v.uuid);
                    await ImplClassApi.delImplClass(array);
                    this.pageTable.handleLoad();
                } finally {
                    this.pageTable.isLoading = false;
                }
            }
        }
    };
</script>
